import { useEffect, useState } from "react";
import { AdminLayout } from "@/components/AdminLayout";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { FAILED_EMAILS_INBOX } from "@/constants/testIds";
import { toast } from "sonner";
import { MailWarning, CheckCircle2 } from "lucide-react";

const EMAIL_TYPE_LABEL = {
  verification: "Verificación de correo",
  password_reset: "Restablecer contraseña",
  welcome_employee: "Bienvenida de empleado",
  data_correction_request: "Aviso de corrección de datos",
};

export default function FailedEmailsInbox() {
  const [items, setItems] = useState([]);

  const load = () => {
    api.get("/failed-emails").then(({ data }) => setItems(data));
  };

  useEffect(load, []);

  const resolve = async (id) => {
    try {
      await api.post(`/failed-emails/${id}/resolve`);
      toast.success("Marcado como resuelto");
      load();
    } catch {
      toast.error("No se pudo marcar como resuelto");
    }
  };

  const pending = items.filter((i) => !i.resolved);

  return (
    <AdminLayout>
      <div data-testid={FAILED_EMAILS_INBOX.page} className="max-w-3xl">
        <h1 className="font-heading text-2xl text-charcoal mb-1">Envíos de correo fallidos</h1>
        <p className="text-sm text-charcoal/60 mb-5">
          Correos que CERH intentó enviar (verificación, bienvenida de empleado, restablecer contraseña, avisos de
          corrección de datos) pero el proveedor de correo (Resend) rechazó. Marca uno como resuelto una vez que
          contactaste manualmente al destinatario o corregiste la causa (ej. dominio verificado en Resend).
        </p>

        {items.length === 0 && (
          <p data-testid={FAILED_EMAILS_INBOX.emptyState} className="text-sm text-charcoal/50 bg-card border border-petroleum/10 rounded-2xl p-6 text-center">
            No hay envíos fallidos registrados.
          </p>
        )}

        <div data-testid={FAILED_EMAILS_INBOX.list} className="space-y-2">
          {items.map((i) => (
            <div key={i.id} data-testid={FAILED_EMAILS_INBOX.row} className="bg-card border border-petroleum/10 rounded-2xl p-4 flex justify-between items-start gap-4">
              <div>
                <p className="text-xs font-semibold text-terracotta uppercase tracking-wide">{EMAIL_TYPE_LABEL[i.email_type] || i.email_type}</p>
                <p className="text-sm text-charcoal mt-1">Para: {i.to}</p>
                <p className="text-xs text-charcoal/60 mt-1">Asunto: {i.subject}</p>
                <p className="text-xs text-red-600 mt-1">{i.error}</p>
                <p className="text-xs text-charcoal/40 mt-1.5">{new Date(i.created_at).toLocaleString("es-MX")}</p>
              </div>
              {!i.resolved ? (
                <Button
                  data-testid={`${FAILED_EMAILS_INBOX.resolveButtonPrefix}-${i.id}`}
                  size="sm" variant="outline"
                  onClick={() => resolve(i.id)}
                  className="rounded-full border-amber-400 text-amber-800 h-7 text-xs shrink-0"
                >
                  <MailWarning className="w-3 h-3 mr-1" /> Marcar resuelto
                </Button>
              ) : (
                <span className="flex items-center gap-1 text-xs font-medium text-emerald-600 shrink-0">
                  <CheckCircle2 className="w-3.5 h-3.5" /> Resuelto
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
